export default __webpack_public_path__ + "static/simple-clients-93ec5ee35207be82c4e6ded3ff3badc7.png";